import React from "react";
import "./About.css";

const About = () => {
  return (
    <div className="about-wrapper">
      <div className="about-container">
        <div className="about-header">
          <span className="about-eyebrow">About us</span>

          <h1 className="about-title">
            About <span>Pryce Technologies</span>
          </h1>

          <p className="about-intro">
            Pryce Technologies is a Singapore-based software and technology
            company specialising in <strong>custom software development</strong>,
            <strong> cloud engineering</strong>,
            <strong> mobile applications</strong>,
            <strong> IoT integrations</strong>, and
            <strong> digital workflow automation</strong>.
          </p>
        </div>

        <div className="about-content">
          <div className="about-card">
            <p className="about-text">
              We build high-performance digital systems that solve real-world
              problems across enterprise applications, operational platforms,
              and intelligent IoT-enabled solutions. Our mission is to empower
              businesses with technology that is <strong>modern</strong>,
              <strong> scalable</strong>, and <strong>future-ready</strong>.
            </p>
          </div>

          <div className="about-card">
            <p className="about-text">
              With a strong background in full-stack development, cloud
              infrastructure, and integrated digital ecosystems, Pryce
              Technologies partners closely with clients to design solutions
              that are purpose-built, reliable, and engineered to accelerate
              growth and performance.
            </p>
          </div>

          <div className="about-card">
            <p className="about-text">
              From concept to deployment, we deliver end-to-end technology
              services that help businesses stay competitive in an increasingly
              digital world.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;